<template>
    <section id="portfolio" class="section bg-light">
        <div class="container">
            <!-- Heading -->
            <h2 class="text-10 fw-600 text-center mb-5" data-aos="fade-up" data-aos-once="true">
                Dahboard Design
            </h2>
            <!-- Heading end-->
            <!-- Filter Menu -->
            <ul class="
          portfolio-menu
          nav nav-tabs
          fw-600
          justify-content-start justify-content-md-center
          border-bottom-0
          mb-4
        " data-aos="fade-up" data-aos-once="true">
                <li class="nav-item">
                    <a data-filter="all" @click="filterbutton" class="nav-link rounded-0 active filter-button">All</a>
                </li>
                <li v-for="navitem in nav_item" :key="navitem" class="nav-item">
                    <a :data-filter="navitem.replace(/\s/g, '').trim().toLowerCase()" @click="filterbutton"
                        class="nav-link rounded-0 filter-button">{{ navitem }}</a>
                </li>

            </ul>
            <!-- Filter Menu end -->
            <div class="portfolio" data-aos="fade-up" data-aos-once="true">
                <div class="row g-4 mt-3 portfolio-filter">
                    <template v-for="appdata in app_image" :key="appdata.id">
                        <div :class="appdata.term_name.replace(/\s/g, '').trim().toLowerCase() + ' col-sm-6 col-lg-4 filter'"
                            @click="project_data(appdata.id)" data-bs-toggle="modal" data-bs-target="#exampleModal">
                            <div class="portfolio-box">
                                <div class="portfolio-img">
                                    <img class="img-fluid d-block"
                                        :src="require(`@/${appdata.projecr_image[0]}`)" alt="" />
                                    <div class="portfolio-overlay">

                                        <div class="portfolio-overlay-details">
                                            <p class="text-primary text-8">
                                                <i class="fas fa-file-alt"></i>
                                            </p>
                                            <h5 class="text-white text-5">{{ appdata.project_title }}</h5>
                                            <span class="text-light">{{ appdata.term_name }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>

                </div>
            </div>
        </div>
    </section>
    <!-- <ModelPopup :title="title" :project_img="project_img" :pdescription="project_desc" :prdate="pdate"
        :ptech="ptechnologies" :purl="psite" /> -->

</template>

<script>
import { Fancybox } from '@fancyapps/ui'
import '@fancyapps/ui/dist/fancybox/fancybox.css'
import jQuery from "jquery";
/* import ModelPopup from "@/components/ModelPopup.vue"; */
import dashboardobj from "@/json/dashboard.json";

export default {
    name: "my-dashboard",
   /*  components: {
        ModelPopup
    }, */
    data() {
        return {
            app_image: dashboardobj,
            nav_item: '',
            title: '',
            project_img: "",
            project_desc: '',
            pdate: '',
            ptechnologies: '',
            psite: ''
        }
    },
    mounted() {
        this.nav_item = [...new Set(this.app_image.map(x => x.term_name))];
    },
    methods: {
        filterbutton(e) {
            let allfilter = e.target.attributes["data-filter"].value;
            if (allfilter == "all") {
                jQuery(".filter").show("1000");
            } else {
                jQuery(".filter")
                    .not("." + allfilter)
                    .hide("3000");
                jQuery(".filter")
                    .filter("." + allfilter)
                    .show("3000");
            }

            jQuery(document).on("click", ".portfolio-menu a", function () {
                jQuery(".portfolio-menu").find("a").removeClass("active");
                jQuery(this).addClass("active");
            });
        },
        project_data(dataid) {
            let navitem = this.app_image.find(x => x.id == dataid);
            this.title = navitem.project_title;
            this.project_img = navitem.projecr_image;
            this.project_desc = navitem.project_desc;
            this.pdate = navitem.project_date;
            this.ptechnologies = navitem.project_technologies;
            this.psite = navitem.project_url;

            const fancyImages = Object.values(navitem.projecr_image).map(img => ({
                src: require(`@/${img}`),
                thumb: require(`@/${img}`)
            }));

            Fancybox.bind('[data-fancybox="gallery"]')
            Fancybox.show(fancyImages, { startIndex: 0 });
        }
    }
}
</script>

<style>

</style>